/**
 * Utility helper for firing custom tracking events via the GrainTag (Grain Analytics) SDK.
 * Handles queuing if the tracking script has not loaded yet when the event is triggered.
 */

const eventQueue = [];

export const trackEvent = (eventName, properties = {}) => {
  if (typeof window === 'undefined') return;

  // Add automatic routing context if available
  const context = {
    path: window.location.pathname,
    referrer: document.referrer || undefined,
    ...properties
  };

  if (window.GrainTag) {
    try {
      window.GrainTag.track(eventName, context);
    } catch (error) {
      console.error('[GrainQL] Error tracking event:', error);
    }
  } else {
    eventQueue.push({ eventName, properties: context });
  }
};

// Start polling for GrainTag to flush the queue when the script loads
if (typeof window !== 'undefined') {
  const flushInterval = setInterval(() => {
    if (window.GrainTag) {
      clearInterval(flushInterval);
      while (eventQueue.length > 0) {
        const { eventName, properties } = eventQueue.shift();
        try {
          window.GrainTag.track(eventName, properties);
        } catch (error) {
          console.error('[GrainQL] Error tracking queued event:', error);
        }
      }
    }
  }, 100);

  // Clear polling after 15 seconds to avoid infinite loops if script fails to load
  setTimeout(() => clearInterval(flushInterval), 15000);
}
